export const suffixItem = [
  {
    label: '@qq.com',
    key: '1',
    hidden: false,
  },
  {
    label: '@126.com',
    key: '2',
    hidden: false,
  },
  {
    label: '@163.com',
    key: '3',
    hidden: false,
  },
  {
    label: '@hotmail.com',
    key: '4',
    hidden: false,
  },
  {
    label: '@foxmail.com',
    key: '5',
    hidden: false,
  },
];

export const regEmail = /^([A-Za-z0-9_\-.]+)@([\w_\-.]+)\.([\w_\-.]+)/;
export const regEmailAbbr = /^([A-Za-z0-9_\-.]+)/;
export const regEmailSuffix = /@([\w_\-.]+)?\.?([\w_\-.]+)?/;

/**
 * 是否邮箱
 * @param {string} value  值
 */
export function isEmail(value: string) {
  return regEmail.test(value);
}

/**
 * 获取气泡列表
 * @param value
 */
export function getPopperList(value: string) {
  let selecteItem: any = [];

  // 邮箱提示后缀
  if (value.match(regEmailAbbr)) {
    if (value.match(regEmailSuffix)) {
      const valueSuffix = (value.match(regEmailSuffix) || [])[0];

      suffixItem.forEach((item) => {
        if (item.label.indexOf(valueSuffix) > -1 && item.label !== valueSuffix) {
          selecteItem.push(item);
        }
      });
    } else {
      selecteItem = suffixItem;
    }
  }

  return selecteItem;
}
